import ModalPharmacyOrderStepOne
  from '@/modals/modal-instructions/modal-pharmacy-orders/modal-view-pharmacy-orders-step-one';
import ModalPharmacyOrderStepTwo
  from '@/modals/modal-instructions/modal-pharmacy-orders/modal-view-pharmacy-orders-step-two';
import ModalPharmacyOrderStepThree
  from '@/modals/modal-instructions/modal-pharmacy-orders/modal-view-pharmacy-orders-step-three';
import ModalPharmacyOrderStepFour
  from '@/modals/modal-instructions/modal-pharmacy-orders/modal-view-pharmacy-orders-step-four';

import ModalViewHipresStepOne from "@/modals/modal-instructions/modal-hipres/modal-view-hipres-step-one";
import ModalViewHipresStepTwo from "@/modals/modal-instructions/modal-hipres/modal-view-hipres-step-two";
import ModalViewHipresStepThree from "@/modals/modal-instructions/modal-hipres/modal-view-hipres-step-three";

export const PHARMACY_ORDERS_INSTRUCTION_ITEM = [
  {
    step: 1,
    component: ModalPharmacyOrderStepOne,
  },
  {
    step: 2,
    component: ModalPharmacyOrderStepTwo
  },
  {
    step: 3,
    component: ModalPharmacyOrderStepThree
  },
  {
    step: 4,
    component: ModalPharmacyOrderStepFour
  }
]

export const HIPRES_INSTRUCTION_ITEM = [
  {
    step: 1,
    titleTextString: 'txt1419',
    component: ModalViewHipresStepOne,
  },
  {
    step: 2,
    titleTextString: 'txt1425',
    component: ModalViewHipresStepTwo
  },
  {
    step: 3,
    titleTextString: 'txt1421',
    component: ModalViewHipresStepThree,
  },
];

export const MODAL_LOCAL_STORAGE_KEYS = {
  PHARMACY_ORDERS: 'NSModalPharmacyOrders',
  HIPRES: 'NSModalhipres'
}

